import { useTranslation } from 'react-i18next'
import { supportedLngs, type SupportedLng } from '@/i18n'

const labels: Record<SupportedLng, string> = {
    es: 'ES',
    en: 'EN',
}

export default function LanguageSwitcher() {
    const { i18n, t } = useTranslation()
    const current = (supportedLngs as readonly string[]).includes(i18n.resolvedLanguage ?? '')
        ? (i18n.resolvedLanguage as SupportedLng)
        : 'es'

    return (
        <div
            className="flex items-center gap-1 bg-white/5 rounded-lg p-0.5"
            role="group"
            aria-label={t('common.language')}
        >
            {supportedLngs.map((lng) => {
                const active = current === lng
                return (
                    <button
                        key={lng}
                        type="button"
                        onClick={() => void i18n.changeLanguage(lng)}
                        aria-pressed={active}
                        className={`px-2 py-1 rounded-md text-[10px] font-black uppercase tracking-widest transition-colors ${active
                            ? 'bg-blue-600 text-white'
                            : 'text-gray-400 hover:text-white'
                            }`}
                    >
                        {labels[lng]}
                    </button>
                )
            })}
        </div>
    )
}
